// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useEffect, useRef } from 'react'

export default function useInfiniteScroll(fetchData: () => void, hasMore: boolean) {
  const observerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const currentRef = observerRef.current // Copy ref to a local variable

    const handleObserver = (entries: IntersectionObserverEntry[]) => {
      try {
        const target = entries[0]
        if (target.isIntersecting && hasMore) {
          fetchData()
        }
      } catch (error) {
        console.error('Error in IntersectionObserver handler:', error)
      }
    }

    // Check if IntersectionObserver is supported
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(handleObserver, {
        root: null,
        rootMargin: '100px', // Increased margin to trigger fetch earlier
        threshold: 0.5, // Adjusted threshold to ensure fetchData is triggered reliably
      })

      if (currentRef) {
        observer.observe(currentRef)
      }

      return () => {
        if (currentRef) {
          observer.unobserve(currentRef)
        }
      }
    } else {
      console.warn('IntersectionObserver not supported, infinite scroll disabled')
      return () => {}
    }
  }, [fetchData, hasMore])

  return observerRef
}
